import { Component } from '@angular/core';
import { OmpPillButtonStyleOptions } from '../../order-management-portal.sections';
import { ompCtaEnabled } from '../../omp.utils';
import { OmpSectionSettings } from '..';

// The button label/link/style trio shared by Text and Image and Callout.
@Component({
  selector: 'omp-cta-fields',
  templateUrl: './omp-cta-fields.component.html',
  styleUrls: ['./omp-controls.scss'],
})
export class OmpCtaFieldsComponent extends OmpSectionSettings {
  public ctaStyleOptions = OmpPillButtonStyleOptions;

  get enabled(): boolean {
    return ompCtaEnabled(this.data);
  }
}
